export default __webpack_public_path__ + "d8775b4558a09230c606b4699fc669a9.svg";